import {LIST} from './types.js';
import {lstorage} from 'utils/lstorage.js';
import {uuid} from 'uuidv4';
import ipfs from 'decentralized/Ipfs.js';
import {getLists} from 'decentralized/lists/ExploreLists.js';

export const fetchLists = async () => {
    let fetched = await getLists();
    let lists = [];
    for (let list of fetched) {
        // let _list = await ipfs.getJson(list.newContent);
        lists.push({
            ... list,
            // ... _list,
            hash: list.newContent,
            tags: [],
            type: LIST
        });
    }

    let unsavedLists = lstorage.getItem("unsavedLists");
    if (!unsavedLists) {
        return lists;
    }
    unsavedLists = JSON.parse(unsavedLists);

    // we dont want to show any old lists that we have edits for
    lists = lists.filter(
        x => !unsavedLists.some(y => y.hash === x.hash));
    return [
        ... lists,
        ... unsavedLists.map(
            list => ({
                ... list,
                id: list.id !== undefined ? list.id : uuid(),
                title: list.name,
                unsaved: true,
                tags: [],
                blockNumber: 9999999999,
                type: LIST
            }))
    ];
}
